var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lesson-name"},[_c('strong',[_vm._v(_vm._s(_vm.lesson.time))]),_vm._v(" "+_vm._s(_vm.lesson.predm)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }